export function CircleRed() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="49"
      viewBox="0 0 49 49"
      fill="none"
    >
      <g filter="url(#filter0_d_3433_3707)">
        <g clipPath="url(#clip0_3433_3707)">
          <path
            d="M2 24.5588C2 12.0999 12.0999 2 24.5588 2C37.0177 2 47.1177 12.0999 47.1177 24.5588C47.1177 37.0177 37.0177 47.1177 24.5588 47.1177C12.0999 47.1177 2 37.0177 2 24.5588Z"
            fill="#5B0014"
          />
          <path
            d="M14 45C21.5 42 38 36 44 36C51.5 36 22 58 14 45Z"
            fill="#B00026"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_3433_3707"
          x="0.754213"
          y="0.754213"
          width="47.6092"
          height="47.6092"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.622893" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3433_3707"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3433_3707"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_3433_3707">
          <path
            d="M2 24.5588C2 12.0999 12.0999 2 24.5588 2C37.0177 2 47.1177 12.0999 47.1177 24.5588C47.1177 37.0177 37.0177 47.1177 24.5588 47.1177C12.0999 47.1177 2 37.0177 2 24.5588Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
